import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  Box,
  Typography,
  DialogContent,
  TextField,
  DialogActions,
  Button
} from "@material-ui/core";
import SecurityOutlined from "@material-ui/icons/SecurityOutlined";
import { FirebaseContext } from "../../FirebaseInit";
import myStyles from "./Style";
class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: "",
      loading: false,
      newpass: "",
      newpasscnf: "",
      repassword: ""
    };
    this.reAuth = this.reAuth.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  closeDialog(e) {
    this.setState({ authenticated: false });
    this.props.toggleDialog();
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  reAuth(user, firebase) {
    this.setState({ loading: true });
    user
      .reauthenticateWithCredential(
        firebase.auth.EmailAuthProvider.credential(
          user.email,
          this.state.repassword
        )
      )
      .then(() => {
        this.setState({ authenticated: true, loading: false });
      })
      .catch(error => {
        this.setState({ loading: false });

        this.props.toggleAlert(error.message, "error");
      });
  }

  updatePassword(firebase) {
    this.setState({ loading: true });
    firebase
      .changePW(this.state.newpass)
      .then(() => {
        this.props.toggleAlert("Password changed!", "success");
        this.setState({
          passwordDialog: false,
          authenticated: false,
          repassword: "",
          newpass: "",
          newpasscnf: "",
          loading: false
        });
        this.props.toggleDialog()
      })
      .catch(err => {
        this.setState({ loading: false });
        this.props.toggleAlert(err.message, "error");
      });
  }
  render() {
    const { classes } = this.props;
    const firebase = this.context;
    const formNotValid =
      this.state.newpass === "" || this.state.newpass !== this.state.newpasscnf;
    return (
      <Dialog
        open={this.props.passwordDialog}
        maxWidth="xs"
        fullWidth
        onClose={this.closeDialog}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        style={{ zIndex: 1350 }}
      >
        <Box p={2} display="flex" alignItems="center" justifyContent="center">
          <SecurityOutlined fontSize="large" color="secondary" />
          <Typography variant="h5">Update Your Password</Typography>
        </Box>
        <DialogContent dividers>
          <Box p={2}>
            {this.state.authenticated ? (
              <>
                <Typography variant="body1">Enter the new password</Typography>

                <TextField
                  name="newpass"
                  required
                  fullWidth
                  margin="normal"
                  value={this.state.newpass}
                  onChange={this.handleChange}
                  disabled={this.state.loading}
                  variant="filled"
                  className={classes.unameInput}
                  type="password"
                  label="Password"
                  size="small"
                />
                <TextField
                  name="newpasscnf"
                  required
                  fullWidth
                  margin="normal"
                  value={this.state.newpasscnf}
                  onChange={this.handleChange}
                  disabled={this.state.loading}
                  variant="filled"
                  className={classes.unameInput}
                  type="password"
                  label="Password confirmation"
                  size="small"
                />
              </>
            ) : (
              <>
                <Typography variant="body1">
                  Please enter your current password
                </Typography>
                <TextField
                  name="repassword"
                  required
                  fullWidth
                  margin="normal"
                  value={this.state.repassword}
                  onChange={this.handleChange}
                  disabled={this.state.loading}
                  variant="filled"
                  className={classes.unameInput}
                  type="password"
                  label="Password"
                  size="small"
                  autoFocus
                />
              </>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          {this.state.authenticated ? (
            <>
              <Button
                name="cancel"
                color="primary"
                disabled={this.state.loading}
                onClick={this.closeDialog}
              >
                Cancel
              </Button>
              <Button
                onClick={this.updatePassword.bind(this, firebase)}
                color="secondary"
                disabled={formNotValid || this.state.loading}
              >
                Update
              </Button>
            </>
          ) : (
            <>
              <Button
                name="cancel"
                disabled={this.state.loading}
                onClick={this.props.toggleDialog}
                color="primary"
                variant="contained"
                size="small"
              >
                Cancel
              </Button>
              <Button
                disabled={this.state.loading}
                onClick={this.reAuth.bind(this, this.props.user, firebase)}
                color="secondary"
                variant="contained"
                size="small"
              >
                Authenticate
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}
ChangePassword.contextType = FirebaseContext;
export default withStyles(myStyles)(ChangePassword);
